var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.158L2.25981 5.22347C1.97161 4.92551 1.50435 4.92551 1.21615 5.22348C0.927948 5.52144 0.927951 6.00453 1.21615 6.30249L7.47817 12.7765C7.76637 13.0745 8.23363 13.0745 8.52183 12.7765L14.7838 6.30249C15.072 6.00453 15.0721 5.52144 14.7839 5.22348C14.4957 4.92551 14.0284 4.92551 13.7402 5.22347L8 11.158Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9bedcef8.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.158L2.25981 5.22347C1.97161 4.92551 1.50435 4.92551 1.21615 5.22348C0.927948 5.52144 0.927951 6.00453 1.21615 6.30249L7.47817 12.7765C7.76637 13.0745 8.23363 13.0745 8.52183 12.7765L14.7838 6.30249C15.072 6.00453 15.0721 5.52144 14.7839 5.22348C14.4957 4.92551 14.0284 4.92551 13.7402 5.22347L8 11.158Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9bedcef8.svg";
export { ForwardRef as ReactComponent };